// React/Next imports
import { useEffect, useState } from 'react';
// Components
import { useInterval } from 'react-use';

import { TranslationService } from '@/utils/services/TranslationService';

// Constants/Libs
import { get } from '@/utils/client';

import { MELTINGSPOT_TOKEN } from '@/lib/routes/apiEndpoints';

import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';

const MELTING_SPOT_SCRIPT_ID = 'meltingspot-frame';
const MELTING_SPOT_SCRIPT_LOAD_DELAY = 500;

export default function IcoAcademy() {
    const [isLoaded, setIsLoaded] = useState(false);

    const retrieveToken = async () => {
        return await get(MELTINGSPOT_TOKEN).then((response) => response.data?.token);
    };

    const loadEmbed = async () => {
        (window as any).MeltingSpot.injectSpotInto('meltingspot-frame', {
            spotId: process.env.NEXT_PUBLIC_MELTINGSPOT_ID,
            themeMode: 'auto',
            authToken: await retrieveToken(),
            deeplink: '/courses'
        });
    };

    useEffect(() => {
        if (!isLoaded) return;

        loadEmbed();
    }, [isLoaded]);

    useInterval(
        () => {
            if (document?.getElementById(MELTING_SPOT_SCRIPT_ID)) {
                setIsLoaded(true);
            }
        },
        isLoaded ? null : MELTING_SPOT_SCRIPT_LOAD_DELAY
    );

    return (
        <WrapperSwitchLayout>
            <div id="meltingspot-frame" style={{ height: 'calc(100vh - 150px)' }}></div>
        </WrapperSwitchLayout>
    );
}

export const getStaticProps = TranslationService.getTranslationMessages();
